import { classNames } from 'primereact/utils';

import { EmissionValueWithSuffix } from '../../../../../../../../../../../../shared/components/emission-value-with-suffix/EmissionValueWithSuffix';
import { DeclaredUnit } from '../../../../../../../../../../../../shared/interfaces/IComponentDetails';
import { EmissionSymbol } from '../../../../../../../../../../../../shared/interfaces/IFootprint';
import styles from '../../CalculationDetails.module.css';

type BiogenicRemovalCardProps = {
  title: string;
  value: number;
  declaredUnit?: DeclaredUnit;
  declaredAmount?: number;
};

const BiogenicRemovalCard = ({ title, value }: BiogenicRemovalCardProps): JSX.Element => {
  return (
    <div
      className={classNames('p-4 border-round-2xl flex w-full flex-column gap-2', styles['card'])}
    >
      <span className='font-medium'>{title}</span>

      <EmissionValueWithSuffix
        emissionValue={value}
        emissionValueDecimals={6}
        declaredUnit={DeclaredUnit.piece}
        abbreviateUnit
        emissionSymbol={EmissionSymbol.KG_CO2E}
        suffixTextClassName='text-black-alpha-60'
        numericalValueTextClassName='text-black text-2xl font-medium'
      />
    </div>
  );
};

export default BiogenicRemovalCard;
